<template>
	<div class="care" v-title="'关注列表'">
		<navtop ></navtop>
		<div class="wrap"  v-bind:style="'overflow:scroll;-webkit-overflow-scrolling: touch;'">
			<div class="focus">
				<div v-for=" item of attentList" v-bind:class="item.isOnline==0?'offLine':'fff'">
				<!--<div v-for=" item of attentList" >-->
					<a v-bind:href="item.isOnline==1?(protocol+'//h5.qxiu.com/room.html?roomid='+item.roomId+'&channelid='+channelid):'javascript:void(0)'">
						<img class="pic" v-bind:src="'https://qiqi-resource-v6.qxiu.com'+item.picUrl_L.slice(29)||'https://static.qxiu.com/h5/static/sDefault.png'" />
					</a>
					<p class="roomInfo"><span>{{item.anchorNickName.slice(0,6)}}</span><span><img class="viewer" src="../../img/dating/viewer.png">{{item.isOnline==0?0:item.roomNum}}</span></p>
					<span v-if="item.isOnline!=0"></span>
	
				</div>
				<p class="empty" v-if="onlingAttentList.length==0">还没有关注主播哦~</p>
			</div>
			<div class="recommend">
				<p></p>
				<ul class="recomList">
					<li v-for=" item of recomList">
						<a v-bind:href="protocol+'//h5.qxiu.com/room.html?roomid='+item.roomId">
							<img v-bind:src="'https://qiqi-resource-v6.qxiu.com'+JSON.parse(item.anchorPic)[0].slice(29)" />
							<p class="roomInfo"><span>{{item.anchorName.slice(0,6)}}</span><span><img class="viewer" src="../../img/dating/viewer.png">{{item.isOnline==0?0:item.roomNum}}</span></p>
							<span class="live"></span>
						</a>
					</li>
				</ul>
			</div>
		</div>
		<!--<navbottom v-bind:index="navBott"></navbottom>-->
	</div>
</template>

<script>
	import navtop from '../dating/navTop'
	import navbottom from '../dating/navBottom'
	import cookie from '../../libs/cookie'

	export default {
		name: 'index',
		data() {
			return {
				navBott: 1,
				attentList: '',
				onlingAttentList: [],
				recomList: '',
				scrollHeight:'',
				protocol: location.protocol
			}
		},
		components: {
			navtop,
			navbottom
		},
		computed:{
			channelid(){
				return cookie.get('channelid')
			}
		},
		mounted() {
			var _this = this
			$.ajax({
				type: "get",
				url: "https://hot-active.qxiu.com/hallhome/recommend/getAttentionRecommendWeb?userId="+cookie.get('uid')+"&openid="+cookie.get('openid')+"&openkey="+cookie.get('accessToken'),
				async: true,
				dataType: "jsonp",
				success: function(res) {
					if(res.result.infos){
						_this.attentList = res.result.infos
						for(var i =0;i<_this.attentList.length;i++){
							if( _this.attentList[i].isOnline!=0){
								_this.onlingAttentList.push(_this.attentList[i])
							}
						}
					}
				}
			});
			$.ajax({
				type: "post",
				url: "https://hot-active.qxiu.com/hallhome/mobile/getMobileAnchorRank?tag=1",
				async: true,
				dataType: "jsonp",
				success: function(res) {
					_this.recomList = res.result.anchors[0].list.slice(0,9)
				}
			});
			
			var height=document.documentElement.clientHeight
			this.scrollHeight=height/parseInt($('html').css('font-size'))-2+'rem';
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.focus {
		margin-top: 2.2rem;
		padding:0.5rem 0 0 0.4rem;
		overflow: hidden;
		background: #fff;
	}
	
	.focus>div {
		float: left;
		position: relative;
		width: 7rem;
		height: 7rem;
		margin:0 0.2rem 0.2rem 0;
		overflow: hidden;
		border-radius: 0.4rem;
	}
	.focus>div a{
		display: block;
		width: 7.4rem;
		height: 7.4rem;
		font-size: 0;
	}
	.focus>div:nth-child(2n) {
		margin-right: 0;
	}
	
	.focus .pic {
		height: 100%;  
    	width: auto;  
	    left:50%;  
	    position: relative;  
	    -webkit-transform: translateX(-50%);  
	    -ms-transform: translateX(-50%);  
	    -moz-transform: translateX(-50%);  
	}
	
	.focus .roomInfo,.recomList .roomInfo {
		position: absolute;
		width: 6.4rem;
		padding: 0 0.3rem;
		bottom: 0.3rem;
		font-size: 0.52rem;
		color: #fff;
		font-weight: 600;
	}
	
	.focus .roomInfo span:last-child ,.recomList .roomInfo span:last-child{
		padding-top: 0.1rem;
		float: right;
		font-size: 0.44rem;
	}
	
	.focus div>span {
		position: absolute;
		top: 0.2rem;	
		right: 0.2rem;
		width: 1.58rem;
		height: 0.6rem;
		background: url(../../img/dating/live.png) no-repeat;
		background-size: 100%;
	}
	.focus .roomInfo span .viewer,.recomList .roomInfo span .viewer{
		width: 0.24rem;
		height: 0.34rem;
		vertical-align: baseline;
		margin-right: 0.16rem;
	}
	.focus .empty{
		text-align: center;
		padding: 2rem 0 1.2rem;
		font-size: 0.52rem;
		color: #c8c8c8;
	}
	
	.recommend {
		margin: 0.4rem 0 0;
		padding-bottom: 2rem;
		background: #fff;
	}
	
	.recommend>p {
		height: 1.74rem;
		margin: 0 0.6rem;
		background: url(../../img/dating/recomend.png) no-repeat left;
		background-size: 4.04rem 0.64rem;
	}
	.recomList {
		overflow: hidden;
		background: #fff;
		padding-left: 0.4rem;
	}
	
	.recomList li {
		float: left;
		width: 7rem;
		height: 7rem;
		position: relative;
		margin: 0 0.2rem 0.2rem 0;
		font-size: 0;
	}
	
	.recomList li:nth-child(2n) {
		margin-right: 0;
	}
	.recomList li a{
		display: block;
	}
	.recomList img {
		width: 7rem;
		height: 7rem;
		border-radius: 0.4rem
	}
	
	.recomList .live {
		position: absolute;
	    top: 0.2rem;
	    right: 0.2rem;
	    width: 1.58rem;
	    height: 0.6rem;
	    background: url(../../img/dating/live.png) no-repeat;
	    background-size: 100%;
	}
	.offLine{
		/*-webkit-filter: grayscale(100%); *//* Chrome, Safari, Opera */
    	/*filter: grayscale(100%);*/
    	display: none;
	}
</style>


// WEBPACK FOOTER //
// care.vue?27164fde